<!--==================================================
    component name  : 空箱查詢 - 彈出視窗 / 地圖查詢
    author          : Samma
    last update     : 2020-05-08
    use description : 
==================================================-->
<template>
  <div class="tab-inner" id="tab02">
    <div class="iframe-rwd" v-if="is_show_content">
      <iframe :src="map_src"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QsTab02',
  data: function () {
    return {
      map_src: null,
      //是否顯示整個 tab 內容
      is_show_content: true,
    };
  },
  mounted: function () {},
  methods: {
    vInitUIStatus: function () {
      this.vShowContent(false);
      this.map_src = null;
    },
    vShowContent: function (is_show) {
      this.is_show_content =
        !this.map_src || this.map_src.length <= 0 ? false : is_show;
    },
    vCheckNoContent: function () {
      return !this.map_src || this.map_src.length <= 0;
    },
    vLoadMap: function (data) {
      this.map_src = data;
    },
  },
};
</script>
